<!--
 * @Author: wbf
 * @LastEditTime: 2024-10-14 11:49:54
 * @Description: 绑定邮箱
-->
<template>
  <div class="box">
    <NavBar
      :title="$t(`webapp.menus.${$route.meta.field}`)"
      :left-arrow="$route.meta.isShowArrow"
      @click-left="$router.back()"
      nav-bar-icon-color="#000"
      class="navbarSelf"
    ></NavBar>

    <Form @submit="onSubmit" class="vertical_self_form">
      <Field
        v-model="form.account"
        name="account"
        :label="$t('base.email.label')"
        :placeholder="$t('base.email.placeholder')"
        :show-error-message="false"
        :scroll-to-error="true"
        :rules="[{ required: true, validator: handlePass }]"
      >
        <template #button v-if="type == 'forget'">
          <div style="color: #2197e7">{{ userInfo.email | handleEmail }}</div>
        </template>
      </Field>
      <Field
        v-model="form.captcha"
        name="captcha"
        :placeholder="$t('base.captcha.placeholder')"
        :show-error-message="false"
        :scroll-to-error="true"
        :rules="[{ required: true }]"
      >
        <template #button>
          <div v-if="count == 60" class="btn" @click="handleSendCode">
            {{ $t("base.btn.get_code") }}
          </div>
          <div v-else class="btn">{{ count }}s</div>
        </template>
      </Field>
      <!-- <div class="remark">登录输入的邮箱去获取验证码</div> -->

      <div style="margin-top: 30px">
        <Button round block type="info" native-type="submit">
          {{
            type == "activate" || type == "forget"
              ? $t("base.btn.next_step")
              : $t("base.btn.bind")
          }}
        </Button>
      </div>
    </Form>
  </div>
</template>

<script>
import { Field, Icon, Form, Button, Toast, NavBar } from "vant";
import { toast } from "@/utils/toast";
import { commonAPI } from "@/apis";
import { delay } from "@/utils";

export default {
  name: "BindEmail",
  components: { Field, Icon, Form, Button, Toast, NavBar },
  data() {
    return { form: {}, type: "", count: 60, userInfo: {} };
  },
  filters: {
    handleEmail(str) {
      if (str) {
        if (str) {
          console.log(str);
          var email = str.replace(str.substring(0, 4), "****");
          return email;
        }
      }
    },
  },
  created() {
    // 账号激活带过来的数据
    this.type = this.$route.query.type;
    if (this.type == "forget") {
      this.userInfo = JSON.parse(localStorage.getItem("FORGET_INFO")) || {};
    } else if (this.type == "activate") {
      this.userInfo = JSON.parse(localStorage.getItem("ACTIVATE_INFO")) || {};
    } else {
      this.userInfo = JSON.parse(sessionStorage.getItem("user")) || {};
      this.form.account = this.userInfo.email;
      this.form = { ...this.form, account: this.userInfo.email };
    }

    console.log(this.type, this.userInfo);
  },
  methods: {
    // 校验邮箱
    handlePass(value) {
      let reg1 = new RegExp(
        /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
      ); // 邮箱
      if (!reg1.test(value)) {
        return false;
      }
      return true;
    },
    // 获取验证码方法
    async getCodeApi(params) {
      const { code, message } = await commonAPI.getAction(
        "/send/msg/sendCaptcha",
        params
      );
      if (code == 0) {
        toast(message);
        // 开启倒计时
        const timer = setInterval(() => {
          if (this.count > 0 && this.count <= 60) {
            this.count--;
          } else {
            this.count = 60;
            clearInterval(timer);
          }
        }, 1000);
      } else {
        toast(message);
      }
    },
    // 获取验证码
    handleSendCode() {
      if (!this.form.account) {
        return toast(this.$t("base.email.placeholder"));
      }
      let params = {
        noticeClassify: 1,
        businessClassify:
          this.type == "activate"
            ? "account_active"
            : this.type == "forget"
            ? "retrieve_password"
            : "change_phone_email",
        ...this.form,
      };

      this.getCodeApi(params);
    },

    async nextCodeApi(params) {
      let forgetUsername = "";
      try {
        forgetUsername =
          this.$route.query.username ||
          this.$route.query.userName ||
          (JSON.parse(localStorage.getItem("FORGET_INFO") || "{}").username) ||
          "";
      } catch (e) {
        forgetUsername = this.$route.query.username || this.$route.query.userName || "";
      }
      const { code, message, data } = await commonAPI.getAction(
        "/user/active/checkCaptcha",
        {
          ...params,
          userAcount: forgetUsername,
          username: forgetUsername,
        }
      );
      if (code == 0) {
        toast(message);
        this.$router.push({
          path: "/mnewPassword",
          query: {
            type: this.type,
            userName: forgetUsername || this.$route.query.username || this.$route.query.userName,
            name: this.$route.query.name,
            businessClassify: params.businessClassify,
            captcha: params.captcha,
            noticeClassify: params.noticeClassify,
            account: params.account,
            resetToken: data,
          }, //表示类型是账号激活或者是忘记密码
        });
      } else {
        toast(message);
      }
    },
    async onSubmit(values) {
      console.log("submit", this.form);

      if (this.type == "activate" || this.type == "forget") {
        //账号激活和忘记密码的绑定邮箱
        let params = {
          noticeClassify: "1",
          businessClassify:
            this.type == "activate"
              ? "account_active"
              : this.type == "forget"
              ? "retrieve_password"
              : "",
          ...this.form,
        };

        this.nextCodeApi(params);
      } else {
        // 首页中的绑定邮箱
        const { code, message } = await commonAPI.postAction(
          `/users/bindEmail/${this.userInfo.username}`,
          this.form
        );
        if (code == 0) {
          toast(message);
          await delay(1000);

          this.$router.push({ path: "/mAuthServer" });
        } else {
          toast(message);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/base.scss";

.box {
  height: 100vh;

  .btn {
    border-radius: 4px;
    color: #2197e7;
    border: 1px solid #2197e7;
    font-size: 14px;
    line-height: 14px;
    padding: 7px 15px;
  }
  .remark {
    color: #9f9f9f;
    text-align: right;
    margin-top: 20px;
  }
}
</style>
